import Actions from '../../odata/actions';

const actions = new Actions('store', 'stores');

export default actions;
